<template>
  <div class="news-detail">
    <div class="detail-header">
      <h1>{{ newsDetail.title }}</h1>
      <div class="meta">
        <span class="time">发布时间：{{ newsDetail.updateTime }}</span>
      </div>
    </div>
    <div class="detail-content">
      <el-image 
        v-if="newsDetail.image" 
        :src="newsDetail.image" 
        :preview-src-list="[newsDetail.image]"
        fit="contain"
        class="detail-image"
      />
      <div class="content-text">
        <p>{{ newsDetail.content }}</p>
      </div>
    </div>
    <div class="detail-footer">
      <el-button @click="goBack">返回</el-button>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';

export default {
  name: 'NewsDetail',
  setup() {
    const route = useRoute();
    const router = useRouter();
    const newsDetail = ref({
      title: '',
      content: '',
      updateTime: '',
      image: ''
    });

    const loadNewsDetail = () => {
      const contentList = JSON.parse(localStorage.getItem('contentList') || '[]');
      const news = contentList.find(item => item.id === Number(route.params.id));
      if (news) {
        newsDetail.value = news;
      } else {
        ElMessage.error('新闻不存在');
        router.push('/');
      }
    };

    const goBack = () => {
      router.go(-1);
    };

    onMounted(() => {
      loadNewsDetail();
    });

    return {
      newsDetail,
      goBack
    };
  }
};
</script>

<style scoped>
.news-detail {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.detail-header {
  margin-bottom: 30px;
  text-align: center;
}

.detail-header h1 {
  font-size: 24px;
  color: #303133;
  margin-bottom: 10px;
}

.meta {
  color: #909399;
  font-size: 14px;
}

.detail-content {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.detail-image {
  width: 100%;
  max-height: 400px;
  margin-bottom: 20px;
  border-radius: 8px;
  object-fit: contain;
}

.content-text {
  line-height: 1.8;
  color: #606266;
}

.content-text p {
  white-space: pre-wrap;
  word-break: break-word;
}

.detail-footer {
  text-align: center;
  margin-top: 20px;
}
</style> 